module.exports = __webpack_public_path__ + "img/philipi_stv106.4c0a108c.png";